import { GenericLazyString } from '@eventbrite/i18n';
import { css } from 'emotion';
import React from 'react';
import FloatingDialog, {
    IFloatingDialogMargins,
} from '../common/floating-dialog';
import UnitsAvailableLine from '../common/units-available-line';
import GoToSectionLine from './section-go-to-line';
import SectionLine from './section-line';

interface ISectionFloatingDialog {
    arrowDialog?: 'top' | 'bottom';
    isDisplay?: boolean;
    position: { x: number; y: number };
    positionType: 'arrow' | 'corner';
    removePanel?: () => void;
    viewport: { width: number; height: number };
    margins: IFloatingDialogMargins;

    handleGoToSection: () => void;
    section: {
        unitsAvailable: number;
        unitsTotal: number;
        title: string;
    };
    tiers: {
        name: string;
        color: string;
        seatsAvailableLabel: GenericLazyString;
        priceLabel: GenericLazyString;
    }[];
}

const SectionFloatingDialog = ({
    arrowDialog,
    handleGoToSection,
    isDisplay,
    margins,
    position,
    positionType,
    removePanel,
    section,
    tiers = [],
    viewport,
}: ISectionFloatingDialog) => {
    const { unitsAvailable, unitsTotal, title } = section;

    return (
        <FloatingDialog
            arrowDialog={arrowDialog}
            position={position}
            isDisplay={isDisplay}
            removePanel={removePanel}
            positionType={positionType}
            viewport={viewport}
            margins={margins}
        >
            <div data-testid="units-available">
                <UnitsAvailableLine
                    title={title}
                    total={unitsTotal}
                    available={unitsAvailable}
                />
            </div>
            <div
                className={css({
                    overflowY: 'auto',
                    maxHeight: '168px',
                })}
            >
                {tiers.map(
                    ({
                        name = '',
                        color = 'white',
                        seatsAvailableLabel,
                        priceLabel,
                    }) => {
                        const content = (
                            <div key={name} data-testid="section-line">
                                <SectionLine
                                    info={{
                                        name,
                                        color,
                                        seatsAvailableLabel,
                                        priceLabel,
                                    }}
                                />
                            </div>
                        );

                        return content;
                    },
                )}
            </div>
            <div data-testid="go-to-section-line">
                <GoToSectionLine goToSection={handleGoToSection} />
            </div>
        </FloatingDialog>
    );
};

export default SectionFloatingDialog;
